import styled from 'styled-components';

export const _Navbar = styled.div`
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 55px;
  align-items: center;
  padding: 2px 10px 2px 20px;
  box-sizing: border-box;
  background: #fff;
  box-shadow: 0 2px 2px rgba(0,0,0,0.1);
  z-index: 200;
`;

export const _NavItem = styled.div`
  margin-left: 5px;
`;

export const _Logo = styled.a`
  font-size: 20px;
  color: #fff;
  margin-top: 0;
  width: 240px;
`;


// WEBPACK FOOTER //
// ./src/components/navbar/styled-navbar.js